export const HAVE_SEEN_ADD_TO_HOME_SCREEN_DIALOG = 'HAVE_SEEN_ADD_TO_HOME_SCREEN_DIALOG';